export var radius = 100 / (2 * Math.PI);
export var width = 42;
export var center = {
  x: width / 2,
  y: width / 2
};